import { useState, useEffect, useContext } from 'react';
import { getTodayDate } from '../../../util/dateUtil';
import ExpertProductApi from '../../../api/ExpertProductApi';
import UserContext from '../../../context/UserContext';
import Payment from '../../../util/Payment';

const DURATION_OPTIONS = [
    { value: 7, label: '7일' },
    { value: 10, label: '10일' },
    { value: 15, label: '15일' },
    { value: 20, label: '20일' },
    { value: 25, label: '25일' },
    { value: 30, label: '30일' },
    { value: 40, label: '40일' },
    { value: 50, label: '50일' },
    { value: 60, label: '60일' },
    { value: 90, label: '90일' },
]

const BASE_PRICE = 4900;
const AD_EXPERT_PRODUCT_ID = 30000

const getProductTitleWithExpireDate = p => {
    const productTitle = p.expert_product_title || '';
    
    // 만료일이 있고 아직 도래하지 않았다면
    if (p.expert_product_end_date) {
        const expireDate = new Date(p.expert_product_end_date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expireDate.setHours(0, 0, 0, 0);
        
        if (expireDate >= today) {
            // MM/DD 형식으로 포맷팅
            const month = String(expireDate.getMonth() + 1).padStart(2, '0');
            const day = String(expireDate.getDate()).padStart(2, '0');
            return `(광고중 ~ ${month}/${day}) ${productTitle}`;
        }
    }
    
    return productTitle;
}

const getMinDate = p => {

}

const RequestModal = ({ onClose }) => {
    const todayStr = new Date().toISOString().split('T')[0];
    const { user } = useContext(UserContext);
    const [price, setPrice] = useState(DURATION_OPTIONS[0].value * BASE_PRICE);
    const [startDate, setStartDate] = useState(todayStr);
    const [minDate, setMinDate] = useState(todayStr);
    const [duration, setDuration] = useState(DURATION_OPTIONS[0].value);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    
    const getCurrentProduct = () => products.filter(p => p.value == selectedProduct)[0];

    const handleProductChange = (e) => {
        setSelectedProduct(e.target.value);
    }

    const handleStartDateChange = (e) => {
        const value = e.target.value;
        if (value < minDate) return;
        setStartDate(value);
    }

    const handleDurationChange = (e) => {
        setDuration(e.target.value);
        setPrice(BASE_PRICE * e.target.value);
    }

    const handlePayBtnClick = () => {

        if (!selectedProduct) return alert("선택된 상품이 없습니다.");

        const payUser = {
            userEmail : user.userEmail,
            userNm : user.userNm,
            userPhone : user.userPhone,
        };

        const data ={
            prodId : AD_EXPERT_PRODUCT_ID,
            subProdId : selectedProduct,
            startDate,
            duration,
            prodTitle : getCurrentProduct()?.label,
            prodDisc: 0,
            prodPrice: price
        };

        Payment.openPaymentPage(data, payUser, '/order/expert/complete', onClose);
    }

    const loadData = () => {
        ExpertProductApi.getExpertProducts({isMine: true, status: 'A'}).then(data => {
            const approvedProducts = data.products.map(p => ({
                value: p.expert_product_id,
                label: getProductTitleWithExpireDate(p),
                endDate: p.expert_product_end_date
            }));
            setProducts(approvedProducts);
            setSelectedProduct(approvedProducts[0].value);
        })
    }

    useEffect(loadData, [])

    useEffect(() => {
        if (!selectedProduct) return;
        const curProduct = getCurrentProduct();
        if (!curProduct || !curProduct.endDate) {
            setStartDate(todayStr);
            setMinDate(todayStr);
        } else {
            const newStartDate = new Date(curProduct.endDate);
            newStartDate.setDate(newStartDate.getDate() + 1);
            let newStartDateStr = newStartDate.toISOString().split('T')[0];
            newStartDateStr = todayStr > newStartDateStr ? todayStr : newStartDateStr;
            setStartDate(newStartDateStr)
            setMinDate(newStartDateStr);
        }
        
    }, [selectedProduct])

    return (
        <div className="modal-dialog open">
            <div className="dim"></div>
            <div className="modal-content">
                <div className="modal-header">
                    <h1>광고 신청하기</h1>
                    <button type="button" className="modal-close" onClick={onClose}>
                        <i className="icon icon-close"></i>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="modal-adv-form">
                        <p className="modal-adv-alert">광고 상품을 이용할 서비스를 선택해주세요</p>
                        <div className="div_row">
                            <span>서비스</span>
                            <div className="input-colgroup">
                                <select onChange={handleProductChange} value={selectedProduct} >
                                    {products.map(p => (
                                        <option key={p.value} value={p.value}>{p.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="div_row">
                            <span>가격</span>
                            <div className="input-colgroup">
                                <p className="price">{BASE_PRICE.toLocaleString()}원<span className="unit">/일</span></p>
                            </div>
                        </div>
                        <div className="div_row">
                            <span>이용시작일</span>
                            <div className="input-colgroup">
                                <input type="date" name="" value={startDate} onChange={handleStartDateChange} min={minDate} />
                            </div>
                        </div>
                        <div className="div_row">
                            <span>이용일</span>
                            <div className="input-colgroup">
                                <select onChange={handleDurationChange}>
                                    {DURATION_OPTIONS.map(option => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="div_row">
                            <span>상품안내</span>
                            <div className="input-colgroup">
                                <p>플러스광고</p>
                            </div>
                        </div>
                        <div className="div_row">
                            <span>최종가격</span>
                            <div className="input-colgroup">
                                <p className="price">{price.toLocaleString()}원</p>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="modal-control">
                    <button type="button" className="btn btn-black" onClick={handlePayBtnClick}>
                        <span>바로구매</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

const ExpertAdRequest = () => {
    const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);


    return (
        <>
            <div className="vh-content-sub">
                <div className="section-area">
                    <div className="section-header">
                        <h1 className="section-header-title">광고상품 이용절차 안내</h1>
                    </div>
                    <div className="section-content">
                        <ul className="adv-step">
                            <li className="circle"><p>광고상품<br /> 신청</p></li>
                            <li className="arrow">
                                <i className="icon icon-arrow-right-p"></i>
                            </li>
                            <li className="circle"><p>서비스<br /> 선택</p></li>
                            <li className="arrow">
                                <i className="icon icon-arrow-right-p"></i>
                            </li>
                            <li className="circle"><p>이용시작일<br /> 설정</p></li>
                            <li className="arrow">
                                <i className="icon icon-arrow-right-p"></i>
                            </li>
                            <li className="circle"><p>기간설정</p></li>
                            <li className="arrow">
                                <i className="icon icon-arrow-right-p"></i>
                            </li>
                            <li className="circle"><p>결제후<br /> 자동게재</p></li>
                        </ul>
                    </div>
                </div>

                <div className="section-area">
                    <div className="section-header">
                        <h1 className="section-header-title">플러스광고</h1>
                    </div>
                    <div className="section-content plus_adv_area">
                        <div className="plus_adv_info">
                            <div className="plus_adv_table">
                                <dl>
                                    <dt>기능</dt>
                                    <dd>
                                        <p>
                                            해당 카테고리<br />
                                            PC, 모바일, 메인 상단 동시 게재
                                        </p>
                                        <p>
                                            오토점프 서비스 무료 제공<br />
                                            (플러스란 최상단으로 매 60분마다 자동 점프업 노출)
                                        </p>
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>적용 플랫폼</dt>
                                    <dd>
                                        <p>PC, Mobile</p>
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>최소 결제일</dt>
                                    <dd>
                                        <p>7일</p>
                                    </dd>
                                </dl>
                            </div>
                            <div className="plus_adv_apply">
                                <div>
                                    <span>1일당</span>
                                    <span className="discount">9,900원</span>
                                    <span className="price">4,900원</span>
                                    <span className="per">50%</span>
                                </div>
                                <button type="button" className="btn btn-primary" onClick={() => setIsRequestModalOpen(true)}>
                                    <span>신청하기</span>
                                </button>
                            </div>
                        </div>
                        <div className="plus_example">
                            <div className="plus_example_img">
                                <div className="plus_example_label">
                                    <span>메인페이지</span>
                                </div>
                                <img src="/static/img/plus_ad_02.png" />
                            </div>
                            <div className="plus_example_img">
                                <div className="plus_example_label">
                                    <span>인증 서비스 페이지</span>
                                </div>
                                <img src="/static/img/plus_ad_01.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isRequestModalOpen && <RequestModal onClose={() => setIsRequestModalOpen(false)} />}
        </>
    )
}

export default ExpertAdRequest;